module.exports = __webpack_public_path__ + "static/media/5.fa0fc41c.jpeg";